"use client";
import dynamic from "next/dynamic";

const HtmlContent = dynamic(() => import("@/components/common/html-content"), {
  ssr: false,
});

type Props = {
  content: string;
};

export default function HTMLNewsContentClient({ content }: Props) {
  return (
    <HtmlContent
      className="flex flex-col gap-2 [&>ol]:list-decimal [&>ol]:ltr:pl-4 [&>ol]:rtl:pr-4 [&>ul]:list-disc [&>ul]:ltr:pl-4 [&>ul]:rtl:pr-4"
      content={content}
    />
  );
}
